import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import DocsLanding from "../../components/feature-docs/DocsLanding";

const Docs = () => {
  const userInfoData = useSelector(selectUser);

  return <DocsLanding userInfoData={userInfoData} />;
};

export default Docs;
